// @ts-ignore
import packageInfo from '../../package.json';
export const environment = {
  production: true,
  apiUrl: 'https://api-vendor.aclarian.com/api/',
  baseUrl: 'https://vendors.browardtax.org',
  appName: 'Broward County Tax Collector | VendorV2',
  tokenizationKey: 'PaQmTu-VE6uUF-9V6acY-jecjXr',
  datadogClientToken: 'pub672ed1c183db8b3c7f17fa922a8bc54c',
  datadogApplicationId: 'e2c3db82-067f-4255-9605-cd32578e5ab5',
  datadogService: 'invoicing_broward_tax_collector',
  ApiKey: 'Qf7@dSzW4#Hu9N%3!',
  env: 'PROD',
  version: packageInfo.version,
};
